import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'vm-flip-card',
  templateUrl: './flip-card.component.html',
  styleUrls: ['./flip-card.component.scss'],
})
export class FlipCardComponent implements OnChanges {
  @Input() value = 0;

  activeValues: Array<number> = [0, 0];

  ngOnChanges(changes: SimpleChanges): void {
    this.activeValues = [changes['value'].currentValue, changes['value'].previousValue];
  }
}
